import {AgBoxSelEditor} from "/@back@/edit/wed/features/boxSel.js";
import {AgCommonBarEditor, IWedEditorCommonBar, OWedEditorCommonBarConfig} from "/@back@/edit/wed/features/commonBar.js";
import {AgTxtSelEditor} from "/@back@/edit/wed/features/txtSel.js";
import {WedModel} from "/@back@/edit/wed/wedCore.js";
import {IWedEdBar, IWedEditor, IWedEditorMain, OWedEditorMainConfig, OWedManagerConfig, WedEditorBase} from "/@back@/edit/wed/wedEditor.js";
import {Action, IActionToggle} from "/@lib@/commons/actions.js";
import {JLastDatas} from "/@lib@/commons/lastDatas.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {OWedEditorBoxConfig} from "/@back@/edit/wed/wedEditorBox.js";

/** Config de l'editor dédié à l'affichage du panel de rendu. */
export interface OWedEditorPreviewConfig extends OWedEditorMainConfig {
}

/** Enrichissements de l'éditor principal pour gérer l'editor de preview. */
export interface IWedEditorPreviewBar extends IWedEditorMain {
	previewBar?: PreviewBar
	previewWedModel?: (() => Promise<WedModel>) | WedModel

	showPreview(show: boolean): void
}

export function AgPreviewBarEditor(cls: any): any {
	const proto = cls.prototype as IWedEditorPreviewBar;

	proto.showPreview = function (this: IWedEditorPreviewBar & IWedEditorCommonBar, show: boolean) {
		if (show) {
			if (!this.previewWedModel) return;
			if (!this.previewBar) {
				const init = Object.create(this.config) as OWedEditorCommonBarConfig & OWedEditorBoxConfig;
				if (this.commonBar) {
					init.commonBar = this.commonBar;
				} else {
					init.hideCommonBar = true;
				}
				init.lastDatasKey = "prv";
				init.lastDatas = this.config.lastDatas && this.config.lastDatas[init.lastDatasKey];
				init.disableBoxSelection = true;
				init.disableVirtuals = this.wedMgr.reg.getPref("wed.previewBar.disableVirtuals", true);
				this.previewBar = new PreviewBar().initialize(init).initPreview(this);
			} else this.previewBar.hidden = false;
			this.barLayout.showBar(this.previewBar)
		} else if (this.previewBar) {
			if (DOM.setHidden(this.previewBar, true)) this.barLayout.onHideBar(this.previewBar);
		}
	};

	if (!proto.initLastDatasHooks) proto.initLastDatasHooks = [];
	proto.initLastDatasHooks.push(function (this: IWedEditorPreviewBar, lastDatas: JLastDatas) {
		if (lastDatas.prv) {
			if (this.wedMgr.rootWedlet) {
				this.showPreview(true);
			} else {
				this.wedMgr.listeners.once("redrawAtEnd", () => {this.showPreview(true)});
			}
		}
	});

	if (!proto.buildLastDatasHooks) proto.buildLastDatasHooks = [];
	proto.buildLastDatasHooks.push(function (this: IWedEditorPreviewBar, lastDatas: JLastDatas) {
		if (this.previewBar && !this.previewBar.hidden) this.previewBar.buildLastDatas(lastDatas);
	});

	return cls;
}

class PreviewBar extends WedEditorBase implements CustomElement, IWedEdBar {
	mainEditor: IWedEditorPreviewBar;

	constructor() {
		super();
		this.id = "previewBar";
		this.setAttribute("label", "Rendu");
	}

	initPreview(mainEditor: IWedEditorPreviewBar): this {
		if (typeof mainEditor.previewWedModel === "function") {
			//Chargement async
			mainEditor.previewWedModel().then((wm) => {
				mainEditor.previewWedModel = wm;
				this.initPreview(mainEditor);
			})
			return this;
		}
		this.mainEditor = mainEditor;
		const mainWedMgr = mainEditor.wedMgr;
		this.wedModel = mainEditor.previewWedModel;
		mainWedMgr.hookFct("clearEditor", () => {this.wedMgr.clearEditor()});
		mainWedMgr.hookFct("detachDocHolder", () => {this.wedMgr.detachDocHolder()});
		const redrawPreview = () => {
			//init de l'editor de l'outline au redraw de l'editor principal.
			this.wedMgr.detachDocHolder(); //en cas d'un redraw suite à un echec / coupure réseau.
			const wedMgrConfig = {} as OWedManagerConfig;
			wedMgrConfig.xaRoot = mainWedMgr.config.xaRoot;
			wedMgrConfig.readOnlyCauses = Array.from(mainWedMgr.readOnlyCauses);
			wedMgrConfig.noFocus = true;
			this.initFromDocHolder(mainWedMgr.docHolderAsync.cloneDocHolder(), wedMgrConfig);
		};
		mainWedMgr.listeners.on("redrawAtEnd", redrawPreview); //futures (re)contrcuxtion
		if (mainWedMgr.drawn) redrawPreview(); //construction si le mainWedMgr est déjà actif.
		return this;
	}
}

AgBoxSelEditor(AgTxtSelEditor(AgCommonBarEditor(PreviewBar)));

customElements.define("wed-preview-bar", PreviewBar);

export class ShowPreviewAction extends Action<IWedEditor & IWedEditorPreviewBar> implements IActionToggle<IWedEditor & IWedEditorPreviewBar> {

	constructor() {
		super("preview");
		this._label = "Rendu";
		this._icon = "/@skin@/edit/wed/previewBtn.svg";

	}

	isVisible(ctx: IWedEditor & IWedEditorPreviewBar) {
		return ctx.previewWedModel != null;
	}

	isToggle(): this is IActionToggle<IWedEditor & IWedEditorPreviewBar> {return true}

	getDatas(api: 'toggle', ctx: IWedEditor & IWedEditorPreviewBar): boolean | null {
		return ctx.previewBar != null && !ctx.previewBar.hidden;
	}

	execute(ctx: IWedEditor & IWedEditorPreviewBar, ev?: Event): any | 'noPreventDefault' {
		ctx.showPreview(!ctx.previewBar || ctx.previewBar.hidden);
	}

}